import React from 'react';
import CardYellow from 'assets/images/backoffice/capital/card-yellow.png';
import CardBlue from 'assets/images/backoffice/capital/card-blue.png';
import CardGreen from 'assets/images/backoffice/capital/card-green.png';
import styles from './ProductCard.css';

function CategoryBorder(props) {
  const { color } = props;
  return (
    <div className={`${styles['category-border']} ${styles[color]}`}>
      {color === 'yellow' && <img src={CardYellow} />}
      {color === 'blue' && <img src={CardBlue} />}
      {color === 'green' && <img src={CardGreen} />}
    </div>
  );
}

export default CategoryBorder;
